import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PostService } from '../../../services/post-service';
import { Post } from '../../../models/post.model';
import { Category } from '../../../models/category.model';
import { Translatable } from '../../../models/translatable.model';
import { Media } from '../../../models/media.model';
import { LocalDatePipe } from '../../../shared/pipes/local-date-pipe';

@Component({
  selector: 'app-sidebar-blog',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule, TranslatePipe, LocalDatePipe],
  templateUrl: './sidebar-blog.html',
  styleUrl: './sidebar-blog.css',
})
export class SidebarBlog implements OnInit {
  searchQuery = '';
  recentPosts: Post[] = [];
  categories: Category[] = [];
  loadingPosts = true;
  loadingCats  = true;

  constructor(
    private postService: PostService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    // Derniers articles
    this.postService.getRecentArticles(5).subscribe({
      next:  posts => { this.recentPosts = posts; this.loadingPosts = false; },
      error: ()    => { this.loadingPosts = false; },
    });

    // Catégories
    this.postService.getCategories().subscribe({
      next:  cats => { this.categories = cats; this.loadingCats = false; },
      error: ()   => { this.loadingCats = false; },
    });
  }

  onSearch(): void {
    if (!this.searchQuery.trim()) return;
    this.router.navigate(['/articles'], {
      queryParams: { q: this.searchQuery.trim() },
    });
  }

  filterByCategory(categoryId: number): void {
    this.router.navigate(['/articles'], {
      queryParams: { category_id: categoryId },
    });
  }

  translateField(field: Translatable | null | undefined): string {
    if (!field) return '';
    const lang = this.translate.getCurrentLang();
    return (field as any)[lang] || field.fr || field.en || '';
  }

  getFeaturedImage(post: Post): string {
    return post.featured_image?.thumb || post.featured_image?.url || '/assets/images/default_image.png';
  }
}
